export default __webpack_public_path__ + "3935cf8136f19f51e0142509115ff7b2.svg";